import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ErrorView from 'scoreboard/components/error-view'

const ScheduledExportsRowError = ErrorView.extend({

	events: _.extend({
		'click .try-again': 'onClickTryAgain'
	}, ErrorView.prototype.events),

	render: function () {
		ErrorView.prototype.render.apply(this, arguments)
		this.$('.close').removeClass('button-primary').addClass('button-default')
		this.$('.dialog-footer').append(
			`<button class="try-again button button-primary">` +
				`${i18n.get('common.tryAgain')}` +
			`</button>`)
	},

	onClickTryAgain: function() {
		this.trigger('done')
	}
})

export default ScheduledExportsRowError
ScheduledExportsRowError.__filename__ = 'admin/scheduled-exports/scheduled-export-error-view.js'
